import IndustryLandingTemplate, { IndustryPageData } from '@/components/industry/IndustryLandingTemplate';

const educationData: IndustryPageData = {
  slug: 'education',
  name: 'Education & Coaching Institutes',
  heroHeadline: 'Let Student Success Stories Build Your Institute\'s Reputation',
  heroSubheadline: 'Help your coaching institute, school, or training center attract more students with authentic Google reviews from successful learners.',
  painPoint: '87% of parents check Google reviews before enrolling their children in coaching institutes',
  trustProblem: 'Most coaching centers have great results but fail to convert them into visible online testimonials.',
  challenges: [
    {
      title: 'Results Without Reviews',
      description: 'Your students crack competitive exams, but their success stories aren\'t visible on Google where new students search.',
    },
    {
      title: 'Local Discovery Problem',
      description: 'Parents searching "best coaching for IIT in Kota" or "NEET coaching near me" can\'t find you.',
    },
    {
      title: 'Generic Testimonials',
      description: 'Reviews saying "good teachers" don\'t mention exam names, ranks achieved, or specific courses.',
    },
    {
      title: 'Seasonal Admission Pressure',
      description: 'During admission season, institutes with better reviews and ratings capture most enrollments.',
    },
  ],
  useCases: [
    {
      category: 'Exam-Specific',
      description: 'Reviews highlighting success in specific competitive exams.',
      keywords: ['IIT JEE coaching', 'NEET preparation', 'UPSC coaching'],
    },
    {
      category: 'Teaching Quality',
      description: 'Reviews focusing on faculty expertise and teaching methodology.',
      keywords: ['experienced faculty', 'doubt clearing', 'personal attention'],
    },
    {
      category: 'Results & Ranks',
      description: 'Reviews showcasing student achievements and rankings.',
      keywords: ['AIR rank', 'selection rate', 'top results'],
    },
  ],
  caseStudy: {
    businessType: 'IIT-JEE Coaching Institute',
    city: 'Kota',
    challenges: [
      'Only 45 reviews despite 15+ years and 500+ selections',
      'Not ranking for "best IIT coaching in Kota" searches',
      'Losing students to newer institutes with better online presence',
    ],
    solution: 'Implemented Review Plum with categories for JEE Main, JEE Advanced, and Foundation courses. Created review templates that highlight AIR ranks and student testimonials.',
    results: [
      { metric: 'Google Reviews', value: '45 → 280' },
      { metric: 'Google Rating', value: '4.2 → 4.8' },
      { metric: 'Admission Inquiries', value: '+120%' },
      { metric: 'Ranking for "IIT Kota"', value: 'Top 3' },
    ],
  },
  sampleReviews: [
    {
      category: 'IIT-JEE Coaching',
      reviews: [
        {
          text: 'Joined this coaching institute for JEE preparation and it was the best decision of my life. The faculty here in Kota is exceptional, especially for Physics and Mathematics. Regular tests and personalized feedback helped me secure AIR 1200 in JEE Advanced. Best IIT coaching in Kota for serious aspirants.',
          keywords: ['IIT coaching in Kota', 'JEE Advanced', 'AIR 1200'],
        },
        {
          text: 'Outstanding coaching center for engineering entrance exams. The study material is comprehensive and the doubt-clearing sessions are very helpful. My son improved from 60 percentile to 98.5 percentile in JEE Main. Highly recommend for students looking for JEE coaching in Rajasthan.',
          keywords: ['JEE coaching', 'engineering entrance', 'JEE Main'],
        },
      ],
    },
    {
      category: 'NEET',
      reviews: [
        {
          text: 'Cracked NEET with AIR 5000 after joining this institute! The Biology faculty is exceptional and explains complex concepts with real-life examples. Regular mock tests helped me manage time during the actual exam. Best NEET coaching in Hyderabad.',
          keywords: ['NEET coaching Hyderabad', 'AIR 5000', 'medical entrance'],
        },
        {
          text: 'My daughter secured admission in a top government medical college thanks to this coaching center. The study material for NEET is comprehensive and up-to-date. Special focus on NCERT made all the difference. Highly recommend for NEET aspirants in Telangana.',
          keywords: ['NEET preparation', 'medical college', 'coaching center Telangana'],
        },
      ],
    },
    {
      category: 'Foundation',
      reviews: [
        {
          text: 'Enrolled my son in Class 10 foundation program and his grades improved dramatically! The teachers build strong fundamentals that prepare students for competitive exams. Best investment for early preparation. Top foundation course in Kota.',
          keywords: ['foundation course Kota', 'Class 10 coaching', 'early preparation'],
        },
        {
          text: 'The foundation batch for Class 8-10 is excellent. My daughter\'s confidence in Physics and Maths has increased significantly. Small batch sizes ensure personal attention. Best for students starting their JEE/NEET journey early.',
          keywords: ['foundation batch', 'Class 8 coaching', 'JEE NEET foundation'],
        },
      ],
    },
  ],
  cityKeywords: [
    'coaching in Kota',
    'IIT coaching Delhi',
    'NEET institute Hyderabad',
    'tuition center Bengaluru',
    'coaching classes Pune',
    'study center Chennai',
  ],
  nearMeKeywords: [
    'coaching near me',
    'tuition classes near me',
    'best coaching nearby',
    'IIT coaching close by',
    'NEET classes near me',
    'study center nearby',
  ],
  ctaText: 'Get More Student Reviews',
};

export default function EducationPage() {
  return <IndustryLandingTemplate data={educationData} />;
}
